import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['kindOfDataInvoices', 'kindOfDataConsumptions', 'stateFilter', 'stepLengthsConsumptionsFilter'];

  static classes = ['hidden'];

  changeKindOfData() {
    // Fields for invoices
    const isInvoices = this.kindOfDataInvoicesTarget.checked
    this.stateFilterTarget.classList.toggle(this.hiddenClass, !isInvoices);

    // Fields for consumptions
    this.stepLengthsConsumptionsFilterTarget.classList.toggle(this.hiddenClass, isInvoices);
  }
}
